import {
    ajaxModalCall
} from './_ajaxModalCall';
import {
	stripRestrictedCharFromInput
} from '../global/_stripRestrictedCharFromInput';
import {
    inlineFormValidationOnBlur
} from '../global/_inlineFormValidationOnBlur';
import {
    submitForm
} from '../global/_submitForm';
import {
	preventDoubleClick
} from '../global/_doubleClick';

export const callAddressAdd = (params, returnHTML) => {
    function myCallback() {
        submitForm();
        stripRestrictedCharFromInput();
        inlineFormValidationOnBlur();
        preventDoubleClick();
    }
    var addressgiftMsg = $("#giftMsgId").find("*").eq(0).val(),
        url = "/webapp/wcs/stores/servlet/AddressAddModalView",
        data = "addressUpdOrderItemId=" + params.addressUpdOrderItemId + "&addressgiftMsg=" + addressgiftMsg + "&orderId=" + params.orderId + "&langId=" + params.langId + "&storeId=" + params.storeId + "&catalogId=" + params.catalogId + "&guestCheckout=" + params.guestCheckout;
    ajaxModalCall(url, data, myCallback, returnHTML);
};
